import { jsx as s } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import c from "classnames";
import { memo as N } from "../../../../../external/preact/compat/dist/compat.module.js";
import E from "../../../SVGIcons/CheckedBox.js";
import C from "../../../SVGIcons/UncheckedBox.js";
import d from "../../../SVGIcons/Checkmark.js";
import { DROPDOWN_ELEMENT_CHECKMARK_CLASS as S, DROPDOWN_ELEMENT_CLASS as D, DROPDOWN_ELEMENT_ACTIVE_CLASS as _, DROPDOWN_ELEMENT_DISABLED_CLASS as p, DROPDOWN_ELEMENT_CONTENT_CLASS as L, DROPDOWN_ELEMENT_ICON_CLASS as O, DROPDOWN_ELEMENT_CHECKBOX_CLASS as f } from "../constants.js";
import u from "../../../Img/Img.js";
import { Fragment as h } from "../../../../../external/preact/dist/preact.module.js";
import { boolOrFalse as A } from "../../../../../utils/value/bool.js";
const M = (e) => e.multiSelect ? /* @__PURE__ */ s("span", { className: f, children: e.selected ? /* @__PURE__ */ s(E, { role: "presentation" }) : /* @__PURE__ */ s(C, { role: "presentation" }) }) : null, T = (e) => e.multiSelect ? null : /* @__PURE__ */ s("span", { className: S, children: e.selected && /* @__PURE__ */ s(d, { role: "presentation" }) }), F = (e) => /* @__PURE__ */ s(h, { children: [
  M(e),
  /* @__PURE__ */ s("div", { className: e.contentClassName, children: [
    e.item.icon && /* @__PURE__ */ s(u, { className: e.iconClassName, alt: e.item.name, src: e.item.icon }),
    /* @__PURE__ */ s("span", { children: e.item.name })
  ] }),
  T(e)
] }), b = ({ item: e, multiSelect: n, onKeyDown: t, onSelect: r, renderListItem: i, selected: l }) => {
  const o = !!e.disabled, m = A(e.disabled) || null, a = c(D, {
    [_]: l,
    [p]: o
  });
  return /* @__PURE__ */ s(
    "li",
    {
      "aria-disabled": o,
      "aria-selected": l,
      className: a,
      "data-disabled": m,
      "data-value": e.id,
      onClick: r,
      onKeyDown: t,
      title: e.name,
      role: "option",
      tabIndex: -1,
      children: i({
        item: e,
        multiSelect: n,
        selected: l,
        contentClassName: L,
        iconClassName: O
      })
    }
  );
}, H = N(b);
export {
  H as default,
  M as renderDefaultMultiSelectionCheckedness,
  T as renderDefaultSingleSelectionCheckedness,
  F as renderListItemDefault
};
